import QuestionQuillEditor from './src/main.js'

export default QuestionQuillEditor



// WEBPACK FOOTER //
// ./src/views/question-editor/components/question-quill-editor/index.js